
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!./../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-5d68d56d\",\"scoped\":true,\"hasInlineConfig\":true}!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Rating.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Rating.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-5d68d56d\"}!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Rating.vue"),
  /* scopeId */
  "data-v-5d68d56d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Rating.vue
// module id = 24
// module chunks = 0